<template lang="html">
    <div>
        <!-- when multiples files are selected  -->
        <template v-if="$store.state.datatable.files.selected.length > 0">
            <p>Êtes-vous sûr de vouloir supprimer les fichiers suivants :</p>
            <ul>
                <li v-for="file in $store.state.datatable.files.selected">
                    {{ file.label }}
                </li>
            </ul>
        </template>
        <!-- just one file selected  -->
        <template v-else>
            <p>Êtes-vous sûr de vouloir supprimer le fichier suivant :</p>
            <ul>
                <li>
                    {{ $store.state.datatable.files.selected.label }}
                </li>
            </ul>
        </template>

    </div>
</template>

<script>
    export default {
        props: {
            params:{
                required: false
            }
        },
        data() {
            return {
                title:          'Supression de fichiers',
                icon:           'delete',
                warning:        true,
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },
            // when form validate
            onValidate() {
                if(this.params.entity) {
                    // when multiple files selected
                    if(this.$store.state.datatable.files.selected.length > 0) {
                        this.$store.state.datatable.files.selected.forEach((item, index) => {
                            this.axios.delete(`/api/${this.params.entity}/${this.$route.params.id}/file/${item.id}`)
                                .then(response => {
                                    this.$store.dispatch('removeSingleData', { key:'files', id:this.$store.state.datatable.files.selected.id})
                                    this.$store.dispatch('updateSingleData', { key:'files_count', value:this.$store.state.single.data.files_count - 1 })
                                    this.$eventHub.$emit('close-modal')
                                    this.$eventHub.$emit('reload-list')
                                })
                                .catch(error => {
                                    console.log(error.response.data)
                                })
                        })
                    } else {
                        // just on file selected
                        this.axios.delete(`/api/${this.params.entity}/${this.$route.params.id}/file/${this.$store.state.datatable.files.selected.id}`)
                            .then(response => {
                                this.$store.dispatch('removeSingleData', { key:'files', id:this.$store.state.datatable.files.selected.id})
                                this.$store.dispatch('updateSingleData', { key:'files_count', value:this.$store.state.single.data.files_count - 1 })
                                this.$eventHub.$emit('close-modal')
                                this.$eventHub.$emit('reload-list')
                            })
                            .catch(error => {
                                console.log(error.response.data)
                            })
                    }
                }
            }
        },

    }
</script>

<style lang="stylus" scoped>
div {
    padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/files/DeleteFiles.vue